<template>
    <ModalBase :show-modal="showModal" @close-modal="close" :auto-h="true" :narrow="true" class="modal-size">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal">
                <template v-slot:title>
                    <span v-if="exportFormat === 'csv'" v-translate>Download XLS Report</span>
                    <span v-if="exportFormat === 'pdf'" v-translate>Precision Settings</span>
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>
            <div>
                <span v-if="exportFormat === 'csv'" class="helper-text" v-translate>Please select the timezone in which you want the exported hours to be displayed.</span>
                <span v-if="exportFormat === 'pdf'" class="helper-text" v-translate>When exporting hours report we translate from time (1 hour 30 minutes) to a quantity (1,5 hours). This option is set by default to your invoice rounding settings. If you want to choose your different precision, please select your preferred option in the menu bellow.</span>

                <b-form>
                    <b-form-row>
                        <b-form-group id="input-group-1"  label-for="input-1">
                            <template slot="label">
                                <span class="selector-label" v-translate>Select Timezone</span>
                            </template>
                            <b-input-group>
                                <b-form-select id="input-1" v-model="selectedTimezone.name">
                                    <b-form-select-option v-for="option in timezoneOptions" :key="option.id" :value="option.name">
                                        {{ option.name }}
                                    </b-form-select-option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-form-row>

                    <b-form-row v-if="exportFormat === 'pdf'">
                        <b-form-group id="input-group-2"  label-for="input-2">
                            <template slot="label">
                                <span class="selector-label" v-translate>Select Rounding Precision</span>
                            </template>
                            <b-input-group>
                                <b-form-select id="input-2" v-model="selectedRoundingPrecision" :options="roundingPrecisionOptions">
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-form-row>
                </b-form>

                <div class="warning-message">
                    <span v-translate>Only assigned hours will be downloaded. Unassigned hours first need to be assigned.</span>
                </div>
            </div>
        </template>

        <template v-slot:actions>
            <GekkoButton @click="selectTimezone()" :text="$gettext('Ok')" class="pull-right" />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase.vue";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import HourService from "@/store/services/hour.service";

export default {
    name: "TimezonePickerModal",
    components: {ModalBase, TitleBar, GekkoButton},
    props: {
        exportFormat: {
            type: String
        }
    },
    data() {
        return {
            showModal: false,
            selectedTimezone: null,
            timezoneOptions: [],
            selectedRoundingPrecision: null,
            roundingPrecisionOptions: [
                { value: 0, text: this.$gettext("Zero decimals (e.g. 1 hour)")},
                { value: 1, text: this.$gettext("One decimal (e.g. 1,2 hours)")},
                { value: 2, text: this.$gettext("Two decimals (e.g. 1,25 hours)")}
            ]
        }
    },
    created() {
        this.selectedRoundingPrecision = 1; // default option
        HourService.getTimezoneList().then((response) => {
            this.timezoneOptions = response.data;
            this.selectedTimezone = this.timezoneOptions.find((option) => option.id === "276"); // 276 is Amsterdam
        });
    },
    methods: {
        close() {
            this.showModal = false;
        },
        selectTimezone() {
            let data = this.selectedTimezone;

            if (this.exportFormat === "pdf")
                data.rounding_precision = this.selectedRoundingPrecision;

                console.log("da Ta", data)

            this.$emit("timezoneSelected", this.selectedTimezone);
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>
.selector-label {
    font-weight: bold;
}

.helper-text {
    font-size: 16px;
    color: $colorTextLight;
}

.warning-message {
    border-radius: 8px;
    background-color: #fcf8e3;
    border: 1px solid #faebcc;
    color: #8a6d3b;
    margin-bottom: 1rem;
    padding: 10px;
    font-size: 16px;
}
</style>